export default __webpack_public_path__ + "static/media/logo-ojk.56537405.svg";